/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column draws a single filled area.`)
};

const es_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica dibuja una única área rellena.`)
};

const de_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte zeichnet eine einzelne gefüllte Fläche.`)
};

const nl_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom tekent één gevuld vlak.`)
};

const fr_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique dessine une seule aire remplie.`)
};

const it_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica disegna una singola area riempita.`)
};

const pt_br2_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha uma única área preenchida.`)
};

const pt_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha uma única área preenchida.`)
};

const ja_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値列が1つの場合、単一の塗りつぶしエリアが描画されます。`)
};

const zh_area_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一列数值绘制出单个填充面积。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_ex1", locale)
	if (locale === "en") return en_area_ex1(inputs)
	if (locale === "es") return es_area_ex1(inputs)
	if (locale === "de") return de_area_ex1(inputs)
	if (locale === "nl") return nl_area_ex1(inputs)
	if (locale === "fr") return fr_area_ex1(inputs)
	if (locale === "it") return it_area_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_area_ex1(inputs)
	if (locale === "pt") return pt_area_ex1(inputs)
	if (locale === "ja") return ja_area_ex1(inputs)
	return zh_area_ex1(inputs)
};